<template>
  <div class="evcontrols">
    <StudyEvConverterSwitcher
      v-if="hasEvConverterSwitch"
      :hasICMConverter
    />
    <StudyRangeHeightSwitcher />
  </div>
</template>

<script>
import StudyRangeHeightSwitcher from '@/components/Switchers/StudyRangeHeightSwitcher'
import StudyEvConverterSwitcher from '@/components/Switchers/StudyEvConverterSwitcher'
// study + trainer
// check solution and switch all 4 options if available

// rest of the app switch EV - EV/POT

export default {
  name: 'StudyControlsRanges',
  components: {
    StudyRangeHeightSwitcher,
    StudyEvConverterSwitcher,
  },
  props: {
    hasICMConverter: Boolean,
    hasEvConverterSwitch: { type: Boolean, default: true },
  },
}
</script>
<style lang="scss" scoped>
.evcontrols {
  display: flex;
  gap: 0.25rem;
  padding: 0 0.25rem;
  background: var(--clr-black-1);
  border-radius: 6px;
  align-items: center;
  justify-content: center;
  max-height: 1.65rem;
}
</style>
